jQuery(document).ready(function($) {

    $( ".bloc_magazines" ).each(function( index ) {

        var parent = $(this)
        var items = parent.find(".magazine")

        if (!items.length) return

        // apparition en cascade des couvertures quand la grille entre dans le viewport
        gsap.from( items, {
            opacity: 0,
            y: 60,
            duration: 0.6,
            ease: "power1.out",
            stagger: 0.08,
            scrollTrigger: {
                trigger: parent,
                start: "top 80%",
                markers: false,
                once: true
            }
        })

    })

});
